<template>
  <WidgetMecleeUiContent :data="data" />
</template>

<script setup>
definePageMeta({
  layout: 'default-light',
});

const { t } = useI18n();
useSeoMeta({
  title: t('b2b.seo.contacts.title'),
  description: t('b2b.seo.contacts.description'),
})

const data = {
  title: t('meclee-ui.pages.contacts.title'),
  content: `<div>
          <p><strong> ТОВ «Меклі» </strong></p>
          <p> ЄДРПОУ 44185169 </p>
          <p> IBAN UA713287040000026007054237217 у АО КБ «Приватбанк»</p>
          <p> Юридична адреса: місто Київ, Дарницький бульвар, 17</p>
  </div>
  <div class="mt-5">
         <p><strong> ФОП Кузьменко Максим Вячеславович</strong></p>
         <p>ЄДРПОУ 3336113596</p>
         <p>IBAN UA833052990000026000014907998</p>
         <p>АТ КБ "ПРИВАТБАНК"</p>
         <p> Юридична адреса: місто Київ, Дарницький бульвар, 17</p>
  </div>
  `
}

</script>
